import { FC, memo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import DesktopNavigation from "./DesktopNavigation";
import { PRODUCT_SLUG } from "@types";
import CourseCardItem from "./CourseCardItem";

import useDesktopCourseSwiper from "./useDesktopCourseSwiper";
import { ICardTab } from "types/card-tab";
import { CourseCardSkeleton } from "@features/home/components/Skeleton/CourseCardSkeleton";

interface propTypes {
  slug: PRODUCT_SLUG;
  activeTab: ICardTab | null;
  onReachEnd?: () => void;
  isLoading?: boolean;
  loadingMore?: boolean;
  firstLoad?: boolean;
  loadedProduct?: boolean;
}

const DesktopCourseSwiper: FC<propTypes> = ({
  slug,
  activeTab,
  onReachEnd,
  isLoading,
  loadingMore,
  firstLoad,
  loadedProduct,
}) => {
  const {
    uniqueSlug,
    showCourse,
    products,
    isEnd,
    handleSwiper,
    handleReachEnd,
    handleSlideChange,
    handleFromEdge,
    handleNavigation,
  } = useDesktopCourseSwiper({
    slug,
    activeTab,
    onReachEnd,
    isLoading,
    firstLoad,
    loadedProduct,
  });

  return (
    <div className="relative">
      <div className="min-w-0 overflow-hidden break-words bg-white w-full courseCard relative [&_.swiper-wrapper]:transform-gpu">
        <Swiper
          observer
          observeParents
          init
          id={`${slug}-desktop`}
          navigation={{
            nextEl: null,
            prevEl: `.swiper-button-prev-${uniqueSlug}`,
          }}
          key={activeTab?.id}
          onSwiper={handleSwiper}
          className={`swiper-${slug} mb-2 grid`}
          slidesPerView="auto"
          spaceBetween={24}
          slidesPerGroup={4}
          onReachEnd={handleReachEnd}
          onSlideChange={handleSlideChange}
          onFromEdge={handleFromEdge}
          modules={[Navigation]}
        >
          {!showCourse
            ? Array(6)
                .fill(0)
                .map((_, index) => (
                  <SwiperSlide
                    key={index}
                    className="my-swiper-course-slide pb-1"
                  >
                    <CourseCardSkeleton />
                  </SwiperSlide>
                ))
            : products.map((product) => (
                <SwiperSlide key={product.id} className="!w-auto">
                  <CourseCardItem
                    product={product}
                    slug={slug}
                    imageWidth={256}
                  />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>

      <DesktopNavigation
        slug={uniqueSlug}
        isLoading={isLoading || false}
        loadingMore={loadingMore || false}
        isEnd={isEnd}
        onNavigation={handleNavigation}
      />
    </div>
  );
};

export default memo(DesktopCourseSwiper);
